// libs
import * as React from 'react'

// classes
import InputArea from 'src/components/forms/input_area/input_area'
import SelectField, {
  ISelectOption
} from 'src/components/forms/select-field/select-field'
import WizardButton, {
  WIZARD_BUTTON_TYPE_CANCEL,
  WIZARD_BUTTON_TYPE_NEXT
} from 'src/components/wizard/wizard_button/wizard_button'
import WizardStep, {
  WIZARD_LAYOUT_MODAL
} from 'src/components/wizard/wizard_step/wizard_step'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import { IFlagCreateData } from 'src/interfaces/flag'

// helpers
import { FlagReason } from '@lopo-tech/lopo-api'
import Translate, { textResources } from 'src/lang/de'
import { validateFlagMessage } from 'src/utils/validation'
import './write_flag.scss'

interface IProps {
  onEnd: () => void;
  onNext: (data: IFlagCreateData) => void;
}

const cls = CLASS_PREFIX + 'write-flag'
const labels = textResources.createFlag

const FLAG_MINIMUM_QUERY_LENGTH = 5

export default class WriteFlag extends React.PureComponent<
  IProps,
  IFlagCreateData
> {
  private reasons: ISelectOption[]

  public constructor (props: IProps) {
    super(props)
    this.save = this.save.bind(this)
    this.handleReasonChange = this.handleReasonChange.bind(this)
    this.handleMessageChange = this.handleMessageChange.bind(this)
    this.state = {
      message: '',
      reason: FlagReason.Other
    }

    this.reasons = [
      {
        text: Translate.createFlagReasons[FlagReason.Harassment],
        value: FlagReason.Harassment
      },
      {
        text: Translate.createFlagReasons[FlagReason.Disinformation],
        value: FlagReason.Disinformation
      },
      {
        text: Translate.createFlagReasons[FlagReason.Violence],
        value: FlagReason.Violence
      },
      {
        text: Translate.createFlagReasons[FlagReason.HateSpeech],
        value: FlagReason.HateSpeech
      },
      {
        text: Translate.createFlagReasons[FlagReason.Spam],
        value: FlagReason.Spam
      },
      {
        text: Translate.createFlagReasons[FlagReason.PrivacyViolation],
        value: FlagReason.PrivacyViolation
      },
      {
        text: Translate.createFlagReasons[FlagReason.Other],
        value: FlagReason.Other
      }
    ]
  }

  public render () {
    const { message, reason } = this.state
    const isValid = validateFlagMessage(message)
    const leftButton = (
      <WizardButton
        onClick={this.props.onEnd}
        textType={WIZARD_BUTTON_TYPE_CANCEL}
      />
    )
    const rightButton = (
      <WizardButton
        onClick={this.save}
        textType={WIZARD_BUTTON_TYPE_NEXT}
        isValid={isValid}
      />
    )

    return (
      <WizardStep
        headerText={labels.title}
        leftButton={leftButton}
        rightButton={rightButton}
        layout={WIZARD_LAYOUT_MODAL}
      >
        <div className={cls}>
          <p className={`${cls}__text`}>{labels.text}</p>
          <SelectField
            label={labels.reason}
            options={this.reasons}
            required={true}
            value={reason}
            onChange={this.handleReasonChange}
          />
          <InputArea
            assistiveText={textResources.shared.inputTooShort(
              FLAG_MINIMUM_QUERY_LENGTH
            )}
            errorText={textResources.shared.inputTooShort(
              FLAG_MINIMUM_QUERY_LENGTH
            )}
            value={message}
            name="message"
            required={true}
            onChange={this.handleMessageChange}
            placeholder={labels.messagePlaceholder}
            initialRows={4}
          />
        </div>
      </WizardStep>
    )
  }

  private handleReasonChange (reason: FlagReason) {
    this.setState({ reason })
  }

  private handleMessageChange (value: string) {
    this.setState({ message: value })
  }

  private save () {
    const { message, reason } = this.state
    if (message && reason) {
      this.props.onNext({ message, reason })
    }
  }
}
